const KIRBY_URL = process.env.REACT_APP_KIRBY_URL ?? "";
const proxyPath = "/api/custom/soal";

const fetchSOALAPI = (path = "/", cache, method = "GET", query = "") => {
  // Check if data is already in cache
  const cacheKey = `[SOAL]${path}${method}${query}`;
  if (cache && cache[cacheKey]) {
    return Promise.resolve(cache[cacheKey]);
  }

  // Route through server-side proxy (token added server-side)
  const cleanPath = path.startsWith("/") ? path.substring(1) : path;
  let url = KIRBY_URL + proxyPath + "/" + cleanPath;

  if (query) {
    url += "?" + query;
  }

  // Make the fetch request
  return fetch(url, { method: "GET" })
    .then((response) => {
      if (response.status >= 400) {
        throw new Error("Bad response from server");
      }
      return response.json();
    })
    .then((json) => {
      // Save the result in cache
      if (cache) cache[cacheKey] = json;
      return json;
    })
    .catch((e) => {
      console.error("Couldn't fetch data => ", e.message);
      return null;
    });
};

export default fetchSOALAPI;
